import styled from 'styled-components';

import { P } from '../../typography';

/* ----------------------- StyledRegistrationTemplate ----------------------- */

export const StyledRegistrationTemplate = styled.div`
    margin: 0 1.5rem 2rem;

    @media screen and (min-width: 27rem) {
        margin: 0 auto 2rem;
        max-width: 24rem;
    }
`;

/* ----------------------------- OtherRegOption ----------------------------- */

export const OtherRegOption = styled.div(
    ({ theme }) => `
        background-color: ${theme.sections.page.d};
        border-radius: 0.5rem;
        margin-top: 1rem;
        padding: 2rem;
        text-align: center;

        ${P} {
            color: ${theme.sections.page.a};
            font-size: 1.125rem;
            font-weight: 500;
            text-align: center;

            &:last-child {
                padding-bottom: 0;
            }
        }

        a {
            color: ${theme.sections.page.feature};
            @media (hover: hover) {
                &:hover {
                    text-decoration: none;
                }
            }
        }

    `,
);
